import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

export const antiAuthGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    // User is already authenticated, redirect to home
    return router.createUrlTree(['/home/map']);
  }

  return true;
};
